// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3Fkhw","cell":"ColumnAccessor_cell__1_iRH","firstCellAccent":"ColumnAccessor_firstCellAccent__2x7oB"};